import React, { useState } from "react";
import { Plus, Minus } from "lucide-react";

export default function FAQAccordion({ items = [] }) {
  const [open, setOpen] = useState(null);
  return (
    <div className="border-t border-soft" data-testid="faq-accordion">
      {items.map((item, idx) => {
        const isOpen = open === idx;
        return (
          <div key={idx} className="border-b border-soft">
            <button
              type="button"
              onClick={() => setOpen(isOpen ? null : idx)}
              className="w-full flex items-center justify-between gap-4 py-6 text-left"
              aria-expanded={isOpen}
              data-testid={`faq-item-${idx}`}
            >
              <span className="font-display text-[22px] sm:text-[26px] text-primary leading-tight">{item.q}</span>
              <span className="flex-shrink-0 w-9 h-9 rounded-full border border-soft flex items-center justify-center text-primary">
                {isOpen ? <Minus size={16} /> : <Plus size={16} />}
              </span>
            </button>
            {isOpen && (
              <div className="pb-6 pr-12 body-md max-w-3xl" data-testid={`faq-answer-${idx}`}>
                {item.a}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
